import ReactEcharts from "echarts-for-react"
import React from "react"
import { Card, Spinner } from "react-bootstrap"

import { getPortStaysChartOptions } from "../helpers/getPortStaysChartOptions"
import { getPortStaysData } from "../helpers/getPortStaysData"
import { VesselStay } from "../hooks/useFetchVesselStays"
import { VesselDetails } from "../hooks/usePrevetAPI"

interface PrevetPortStaysProps {
  vesselDetailsData: VesselDetails
  vesselStaysData: VesselStay[] | undefined
  isVesselStaysLoading: boolean
  isVesselStaysError: boolean
}

export function PrevetPortStays({
  vesselDetailsData,
  vesselStaysData,
  isVesselStaysError,
  isVesselStaysLoading,
}: PrevetPortStaysProps): JSX.Element {
  const portStaysData = vesselStaysData && getPortStaysData(vesselStaysData)
  return (
    <React.Fragment>
      <Card className="PrevetContainer_PortStaysGraph h-100">
        <Card.Body className="w-100">
          {isVesselStaysLoading && (
            <div className="d-flex flex-column align-items-center">
              <Spinner className="mb-3" animation="border" role="status" />
              <div>Loading vessel stays...</div>
            </div>
          )}
          {isVesselStaysError && (
            <div className="d-flex justify-content-center">
              Error loading vessel stays
            </div>
          )}
          {portStaysData && (
            <>
              <div className="d-flex justify-content-between">
                <div>
                  <h4 style={{ marginBottom: "1.2rem" }} className="card-title">
                    Port Stays
                  </h4>
                </div>
              </div>
              <div className="d-flex w-100">
                <ReactEcharts
                  style={{
                    height: "420px",
                    width: "100%",
                  }}
                  option={getPortStaysChartOptions({
                    portStaysData,
                    vesselInfo: vesselDetailsData,
                  })}
                />
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </React.Fragment>
  )
}
